module.exports = __webpack_public_path__ + "media/images/service/n_16-a464c80ba143e23af89ef60bbcedc9ba.jpg";